export const KisqaliQuestionsConstants = {
  patientCondition: "condition",
};
